import React, {PureComponent} from "react";
import {Icon, Button, Sidebar, Card} from "semantic-ui-react";
import {connect} from "react-redux";
import { Select } from 'semantic-ui-react';
import PropTypes from "prop-types";
import { withRouter } from 'react-router';
import * as showSeasonActions from "../../store/showSeason/showSeasonActions";
import { selectCountry } from '../../store/country/countryActions';

const numbersToWords = {
  2: 'Two',
  3: 'Three',
  4: 'Four',
  5: 'Five',
  6: 'Six',
  7: 'Seven',
  8: 'Eight',
  9: 'Nine',
};


class MobileApplyNow extends PureComponent {
  static propTypes = {
    season: PropTypes.object,
    visible: PropTypes.bool,
    setShowApplicants: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    countries: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string,
        value: PropTypes.string
      })
    ).isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      showCountry: false,
      showCountryTeam: false
    };
  }

  redirectToApply = () => {
    this.props.history.push('/apply');
  };

  componentDidUpdate(nextProps) {
    this.setState({visible: nextProps.visible});
  }

  handleClose = () => {
    this.props.toggleVisibility();
  };

  handleCountrySelect = (e, { value }) => {
    if (value) {
      this.props.selectCountry(value);
      this.redirectToApply();
    }
  };

  renderCountrySelect() {
    return (
      <Select
        className="country-select"
        fluid
        label="Country"
        options={this.props.countries}
        onChange={this.handleCountrySelect}
        placeholder="Country"
      />
    )
  }

  apply = (numberOfApplicants, isTeam) => {
    this.props.setShowApplicants(numberOfApplicants);
    if (this.props.countries.length > 1) {
      if (!isTeam) {
        this.setState({showCountryTeam: false, showCountry: true});
      } else {
        this.setState({showCountryTeam: true, showCountry: false});
      }
    } else {
      this.props.selectCountry(this.props.countries[0].value);
      this.redirectToApply();
    }
  };

  renderApplyButtonSection() {
    const { season } = this.props;
    let divClass = this.state.showCountry ? 'margin-top-apply' : '';


    if (season.activelyCastingC) {
      if (season.numberOfApplicantsC <= 1 || season.onlyTeamC) {
        return (
          <div className="content shaded padded">
              <Button
                onClick={() =>  this.apply(1, false)}
                className="ui huge fluid primary right labeled icon button"
                style={{ backgroundColor: `#${season.hexColorCodeC}` }}
              >
                <Icon className="right chevron" />
                Apply Now
              </Button>
              {this.state.showCountry &&
                this.renderCountrySelect()
              }
          </div>
        );
      }

      return (
        <div className="content shaded padded">
            <Button
              onClick={() => {
                  this.apply(+season.numberOfApplicantsC, true);
                }}
              className="ui huge fluid primary right labeled icon button"
              style={{ backgroundColor: `#${season.hexColorCodeC}` }}
            >
              <Icon className="right chevron" />
              Team of {numbersToWords[season.numberOfApplicantsC]}
            </Button>
            {this.state.showCountryTeam &&
              this.renderCountrySelect()
            }
            <Button
              onClick={() => {
                  this.apply(1, false);
                }}
              className="ui huge fluid primary right labeled icon button"
              style={{ backgroundColor: `#${season.hexColorCodeC}` }}
            >
              <Icon className="right chevron" />
              Singles
            </Button>
            {this.state.showCountry &&
              this.renderCountrySelect()
            }
        </div>
      );
    }
  }

  render() {
    const render = this.renderApplyButtonSection();

    return (
        <Sidebar
          visible={this.props.visible}
          id="mobileApply"
          className="ui top"
        >
          <Card id="applyCard" className="ui fluid">
            <div className="content inverted">
              <div className="header">
                <h2 style={{ display: 'inline-block' }}>Apply Now!</h2>
                <span className="close-sidebar" onClick={this.handleClose}>x</span>
              </div>
            </div>
            {render}
          </Card>
        </Sidebar>
    );
  }
}

const mapStateToProps = state => ({
  countries: state.country.countries.map(country => ({
    text: country.name,
    value: country.sfId
  }))
});

const mapDispatchToProps = dispatch => ({
  selectCountry: countrySfId => dispatch(selectCountry(countrySfId)),
  setShowApplicants: applicants =>
    dispatch(showSeasonActions.setShowApplicants(applicants)),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MobileApplyNow)
);



// WEBPACK FOOTER //
// ./src/components/common/MobileApplyNow.js